import React from 'react';
import { TEAM_BIOS } from '../../data/teamBios';

/**
 * Team bio cards — photo(s) + name + role + multi-paragraph bio.
 * Sits above the open-roles section on the Team page.
 *
 * Photos render stacked top-to-bottom on the left side of each bio card.
 * Bio text supports paragraphs by splitting on blank lines (\n\n) so the
 * JSON stays readable in the CMS while the rendered HTML breaks correctly.
 */
export function TeamBios() {
  return (
    <section className="section fade-in">
      <div className="section-label">The Team</div>
      <h2>Who’s building TrueNooch™.</h2>
      <div className="team-bios">
        {TEAM_BIOS.map((member) => (
          <article key={member.name} className="team-bio">
            {member.photos && member.photos.length > 0 && (
              <div className="team-bio-photos">
                {member.photos.map((photo, i) => (
                  <div key={photo} className="team-bio-photo-wrap">
                    <img
                      src={`${process.env.PUBLIC_URL}${photo}`}
                      alt={`${member.name} — photo ${i + 1}`}
                      className="team-bio-photo"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="team-bio-text">
              <h3 className="team-bio-name">{member.name}</h3>
              <p className="team-bio-role">{member.role}</p>
              <div className="team-bio-paragraphs">
                {member.bio.split('\n\n').map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
